export const STORAGE_KEY_URL_QUERIES = 'url_queries'
